import React, { useEffect, useState } from 'react'
import Icon from '../Icon'
import Button from './Button'
import './ui.css'

/**
 * Пагинация списков: «from–to из total» и компактные ghost-кнопки со стрелками (как в макете клиентов).
 *
 * @param {{ page: number, pages: number, onPageChange: (page: number) => void, total?: number, pageSize?: number, showIcons?: boolean }} props
 */
function Pagination ({ page, pages, onPageChange, total, pageSize, showIcons = true }) {
  const safePages = Math.max(1, pages || 1)
  const [destination, setDestination] = useState(String(page))
  useEffect(() => setDestination(String(page)), [page])
  const numbers = [...new Set([1, page - 1, page, page + 1, safePages])]
    .filter(number => number >= 1 && number <= safePages).sort((a, b) => a - b)
  const hasRange =
    typeof total === 'number' &&
    total > 0 &&
    typeof pageSize === 'number' &&
    pageSize > 0

  if (!hasRange && safePages <= 1) return null

  const start = hasRange ? Math.min((page - 1) * pageSize + 1, total) : null
  const end = hasRange ? Math.min(page * pageSize, total) : null
  const infoText = hasRange
    ? `${start}–${end} из ${total}`
    : `Страница ${page} из ${safePages}`

  return (
    <div
      className="ui-pagination ds-table-pagination"
      role="navigation"
      aria-label="Пагинация"
    >
      <span className="ds-pagination-info">{infoText}</span>
      <div className="ds-pagination-controls">
        <Button
          type="button"
          variant="ghost"
          size="sm"
          onClick={() => onPageChange(page - 1)}
          disabled={page <= 1}
          aria-label="Предыдущая страница"
        >
          {showIcons ? <Icon name="chevronLeft" size={16} /> : null}
        </Button>
        {numbers.map((number, index) => (
          <React.Fragment key={number}>
            {index > 0 && number - numbers[index - 1] > 1 ? <span aria-hidden="true">…</span> : null}
            <Button variant={number === page ? 'primary' : 'ghost'} size="sm"
              aria-label={`Страница ${number}`} aria-current={number === page ? 'page' : undefined}
              onClick={() => onPageChange(number)}>{number}</Button>
          </React.Fragment>
        ))}
        <Button
          type="button"
          variant="ghost"
          size="sm"
          onClick={() => onPageChange(page + 1)}
          disabled={page >= safePages}
          aria-label="Следующая страница"
        >
          {showIcons ? <Icon name="chevronRight" size={16} /> : null}
        </Button>
        {safePages > 7 && <form className="ds-pagination-jump" onSubmit={event => {
          event.preventDefault()
          const value = Number(destination)
          if (Number.isInteger(value) && value >= 1) onPageChange(Math.min(safePages, value))
        }}>
          <input type="number" min="1" max={safePages} value={destination}
            aria-label="Перейти на страницу" onChange={event => setDestination(event.target.value)} />
          <Button type="submit" variant="ghost" size="sm">Перейти</Button>
        </form>}
      </div>
    </div>
  )
}

export default Pagination
